<template>
    <div>
    <svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.2299 41.3799L20.6899 40.0199L3.6599 21.6899L40.3999 21.6899L40.3999 19.6899L3.6599 19.6899L20.6899 1.36988L19.2299 -0.000120106L-9.73734e-05 20.6899L19.2299 41.3799Z" fill="#222221"/>
                </svg>
    </div>
  </template>
  <style scoped>
  svg{
    width: 28px;
    height: auto;
  }
  </style>
  
  